var equalheight = function () {
  $('.grid-link__image-centered').equalHeights();
}

document.addEventListener("DOMContentLoaded", function() {
  var endlessScroll = new Ajaxinate({
    container: '#AjaxinateLoop',
    pagination: '.pagination_bottom',
    callback: equalheight
  });
});



//read more button text
function myFunction() {
  var dots = document.getElementById("dots");
  var moreText = document.getElementById("more");
  var btnText = document.getElementById("myBtn");

  if (dots.style.display === "none") {
    dots.style.display = "inline";
    btnText.innerHTML = "Read more"; 
    moreText.style.display = "none";
  } else {
    dots.style.display = "none";
    btnText.innerHTML = "Read less"; 
    moreText.style.display = "inline";
  }
}

$(document).ready(function() { 
  
  $('.grid-link__image-centered').equalHeights();
  
  $('.child').hide();
  $(".sidebar-nav-toggle").click(function(){
    var myparent=$(this).parent();
    $(".child", myparent).each(function(){
      $(this).toggle();      
    });
  });



  $('.cart-button').click(function(event){
    event.preventDefault();
    ajaxCart.load();
    $('.drop-cart').addClass('open');
    $('body').addClass('open-cart');
    
    setTimeout(function(){
      $('.drop-cart').removeClass('open');
      $('body').removeClass('open-cart');
    }, 3000);
    
  });
  
  $(document).bind('mouseup touchend', function(e){
    var container = $('.drop-cart');
    if ($('.drop-cart').hasClass('open')) {
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        $('.drop-cart').removeClass('open');
        $('body').removeClass('open-cart');
      }
    }
  });
  
  
  // Accordion Faq page
  var acc = document.getElementsByClassName("accordion");
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].onclick = function(){
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.display === "block") {
        panel.style.display = "none";
      } else {
        panel.style.display = "block";
      }
    }
  }
  
  $('.mobile-nav-trigger').click(function(){
    $('#mobile-sidebar').addClass('open');
    $('body').addClass('menu-drawe-open');
  });
  
  $('.mobile-nav-close').click(function(){
    $('#mobile-sidebar').removeClass('open');
    $('body').removeClass('menu-drawe-open');
  });

  $(document).bind('mouseup touchend', function(e){
    var container = $('.sidenav');
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      $('#mobile-sidebar').removeClass('open');
      $('body').removeClass('menu-drawe-open');
    }
  });
  
  
    // Add or remove from the quantity
    $('.cart_qty .js-qty__adjust').on('click', function () {
      
      var $el = $(this),
          $qtySelector = $el.siblings('.js-qty__num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      // Add or subtract from the current quantity
      if ($el.hasClass('js-qty__adjust--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      $qtySelector.val(qty);

      $('.update-cart').trigger('click');
    });
  
  
  // smooth scrolling

  // Add smooth scrolling to all links
  $("a").on('click', function(event) {

    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {
      // Prevent default anchor click behavior
      event.preventDefault();

      // Store hash
      var hash = this.hash;

      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $('html, body').animate({
        scrollTop: $(hash).offset().top
      }, 800, function(){

      });
    } // End if
  });
  
  // Add smooth scrolling to all links
  $('.scrollSelect').on('change', function () {

    // Make sure this.hash has a value before overriding default behavior
    if ($(this).val() !== "") {

      // Store hash
      var hash = $(this).val();

      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $('html, body').animate({
        scrollTop: $(hash).offset().top
      }, 800, function(){

      });
    } // End if
  });
  
  //	Featured Product Carousel
  $('.featured-product').owlCarousel({
    loop: true,
    margin: 20,
    responsiveClass: true,
    navText:["<div class='nav-btn prev-slide'></div>","<div class='nav-btn next-slide'></div>"],
    nav: true,
    dots: false,
    responsive: {
      0: {
        items: 1
      },
      481: {
        items: 2
      },
      769: {
        items: 3
      },
      992: {
        items: 5
      }
    }
  });  
  
  //	Featured Product Carousel
  $('.featured-collection-slider').owlCarousel({
    loop: true,
    margin: 30,
    responsiveClass: true,
    navText:["<div class='nav-btn prev-slide'></div>","<div class='nav-btn next-slide'></div>"],
    nav: false,
    dots: false,
    responsive: {
      0: {
        items: 1,
        dots: true
      },
      481: {
        items: 2,
        dots: true
      },
      769: {
        items: 3
      },
      992: {
        items: 3
      }
    }
  });  
  
  //	New Product Carousel
  $('.new-product').owlCarousel({
    loop: true,
    margin: 20,
    responsiveClass: true,
    navText:["<div class='nav-btn prev-slide'></div>","<div class='nav-btn next-slide'></div>"],
    nav: true,
    dots: false,
    responsive: {
      0: {
        items: 1
      },
      481: {
        items: 2
      },
      769: {
        items: 3
      }
    }
  }); 
  
  //	Related Product Carousel
  $('.related-product').owlCarousel({
    loop: true,
    margin: 20,
    responsiveClass: true,
    navText:["<div class='nav-btn prev-slide'></div>","<div class='nav-btn next-slide'></div>"],
    nav: true,
    dots: false,
    responsive: {
      0: {
        items: 1
      },
      481: {
        items: 2
      },
      769: {
        items: 3
      }
    }
  });
  
  // collection filter  
  $('.collection-sorting-brand').click(function(){
    $('.brand-by').toggleClass('open');
    $('.designer-by').removeClass('open');
    $('.filter-by').removeClass('open');
    $('.sorting-brand-arrow').toggleClass('arrow-reverse');
    $('.sorting-designer-arrow').removeClass('arrow-reverse');
    $('.filter-brand-arrow').removeClass('arrow-reverse');
  });
  
  $('.collection-sorting-designer').click(function(){
    $('.designer-by').toggleClass('open');
    $('.brand-by').removeClass('open');
    $('.filter-by').removeClass('open');
    $('.sorting-designer-arrow').toggleClass('arrow-reverse');
    $('.sorting-brand-arrow').removeClass('arrow-reverse');
    $('.filter-brand-arrow').removeClass('arrow-reverse');
  });
  
  $('.collection-sorting-filter').click(function(){
    $('.filter-by').toggleClass('open');
    $('.designer-by').removeClass('open');
    $('.brand-by').removeClass('open');
    $('.filter-brand-arrow').toggleClass('arrow-reverse');
    $('.sorting-designer-arrow').removeClass('arrow-reverse');
    $('.sorting-brand-arrow').removeClass('arrow-reverse');
  });
    
  //Search header drop
  $('.search-drop').click(function(){
    $('.site-nav-search-form').toggleClass('open');
  });
  
  //Project tab menu
  $('ul.project-tabs li').click(function(){
    var tab_id = $(this).attr('data-tab');

    $('ul.project-tabs li').removeClass('current');
    $('.project-tab-content').removeClass('current');

    $(this).addClass('current');
    $("#"+tab_id).addClass('current');
  })
  
  
  // bind change event to select
  $('.redirectSelect').on('change', function () {
    var url = $(this).val(); // get selected value
    if (url) { // require a URL
      window.location = url; // redirect
    }
    return false;
  });
  
  
});  

$(document).on('ready', function(){
  cookiesPolicyBar();
});

function cookiesPolicyBar(){
  // Check cookie 
  if ($.cookie('cookieAlert') != 'active') $('#cookieAcceptBar').show(); 
  //Assign cookie on click
  $('#cookieAcceptBarConfirm').on('click',function(){
    $.cookie('cookieAlert', 'active', {path: '/', expires: 5 }); // cookie will expire in one day
    $('#cookieAcceptBar').fadeOut();
  });
}  

//	Sticky header
$(window).scroll(function() {
  var sticky = $('.site-header, .mobile-navigation-wrapper'),
      scroll = $(window).scrollTop();

  if (scroll >= 600) { 
    sticky.addClass('fixed'); }
  else { 
    sticky.removeClass('fixed');

  }
});



